import gqls from "@/graphql/storeManage.gql";
import {
  queryDataDictionaryListLang,
  queryDataDictionaryPages
} from "@/graphql/Common.gql";
// callback 调用
import { resRest, easyMutate } from "@root/lib/utils";
import { getResPaginationData, getResData } from "@root/utiles/common";
import { httpServer as http } from "@/lib/axios";

import BbqActions from "@root/lib/bbqActions";
const shortAction = new BbqActions(gqls, []);
const gqlActions = shortAction.getValues();

const storeManage = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    ...gqlActions,
    // 获取系统，市场，品牌
    async getScanSystemData({ dispatch, commit, state }) {
      // 系统
      if (!state.wtScanSystem || !state.wtScanSystem.length) {
        let data = await dispatch("queryDataDictionaryPages", {
          statePath: "wtScanSystem",
          ddCode: "WT_SYSTEM"
        });
        try {
          data = JSON.parse(data && data[0].value);
        } catch (e) {
          console.log(e);
          data = [];
        }

        // 得到市场和品牌
        let marketData = [];
        let brandData = [];
        const collect = (data = [], metaData = []) => {
          data.map(item => {
            if (!metaData[0] || !metaData.find(o => o.label === item.label)) {
              metaData.push(item);
            }
          });
          return metaData;
        };
        data.forEach(system => {
          marketData = collect(system.children, marketData);
          system.children.forEach(market => {
            brandData = collect(market.children, brandData);
          });
        });
        commit("easyMutate", { path: "wtScanSystem", data });
        commit("easyMutate", { path: "wtScanMarket", data: marketData });
        commit("easyMutate", { path: "wtScanBigBrand", data: brandData });
      }
    },
    // 数据字典，另个接口。。。
    async queryDataDictionaryPages(
      { rootState, commit },
      { statePath: path, ddCode }
    ) {
      const { list: data = [] } = getResPaginationData(
        await rootState.gql.query({
          query: queryDataDictionaryPages,
          variables: {
            input: { ddCode },
            pageInput: { pageSize: 100000, pageNum: 1 }
          }
        })
      );
      commit("easyMutate", { path, data });
      return data;
    },
    // 获取数据字典
    async queryDataDictionaryListLang(
      { rootState, commit, state },
      { statePath: path, ddCode }
    ) {
      // 存在就不用查询
      if (state[path]) return state[path];
      const res = await rootState.gql.query({
        query: queryDataDictionaryListLang,
        variables: {
          input: {
            ddCode
          }
        }
      });

      commit("easyMutate", {
        path,
        data: res.data.api || []
      });

      return res.data.api;
    },
    // 获取k1门店管理列表
    async getK1CustomerManagePageRest({ rootState }, params = {}) {
      const data = await http("/k1/custom/store/manage/queryList", params);
      return data ? data.data || [] : { list: [], total: 0 };
    },
    // 门店管理列表的详情
    async queryGitiCustomDetailRest({ rootState }, params = {}) {
      const data = await http("/k1/custom/store/manage/queryDetail", params);
      return data.data || {};
    },
    // 获取导出配置项
    async queryExportFieldsRest({ rootState }, params = {}) {
      const data = await http(
        "/k1/custom/store/manage/getExportFields",
        params,
        { errorMessage: true },
        "get"
      );
      return data.data || [];
    },
    // 门店管理导出数据
    async exportGitiCustomStoreRest({ rootState }, params = {}) {
      await http("/k1/custom/store/manage/export", params);
    },
    // 门店管理KA导出数据
    async exportKaStoreRest({ rootState }, params = {}) {
      await http("/k1/custom/store/manage/exportKaStore", params);
    }
  },
  mutations: {
    easyMutate
  }
};
export default storeManage;
